import React from "react";
import { createRoot } from "react-dom/client";
import Workflows from "./src";
import { pageProps } from "./src/helpers/pageProps";
// import { createInertiaApp } from "@inertiajs/inertia-react";

// const root = createRoot(document.getElementById("app"));

window.apiToken = JSON.parse(
  document.querySelector("#app").dataset.page
).props.apiToken;
console.log(pageProps)
// createInertiaApp({
//   resolve: (name) => require(`./Pages/${name}`),
//   setup({ App, props }) {
//     root.render(<App {...props} />);
//   },
// });

const root = createRoot(document.getElementById("app"));

// Flash the loader to 100% before React replaces the DOM
const bar = document.getElementById('wf-loader-bar');
const lbl = document.getElementById('wf-loader-label');
if (bar) bar.style.width = '100%';
if (lbl) lbl.textContent = 'Ready!';

root.render(<Workflows />);
